import api from './api';
import { CreateOrderDto, OrderResponse, OrderListItem } from '../types/order.types';

class OrderService {
  /**
   * Создание нового заказа
   */
  async createOrder(data: CreateOrderDto): Promise<OrderResponse> {
    const response = await api.post<OrderResponse>('/orders', data);
    return response.data;
  }

  /**
   * Получение списка заказов
   */
  async getOrders(): Promise<OrderListItem[]> {
    const response = await api.get<OrderListItem[]>('/orders');
    return response.data;
  }

  /**
   * Получение заказа по ID
   */
  async getOrder(id: number): Promise<OrderResponse> {
    const response = await api.get<OrderResponse>(`/orders/${id}`);
    return response.data;
  }

  /**
   * Обновление статуса заказа
   */
  async updateOrderStatus(id: number, status: string): Promise<OrderResponse> {
    const response = await api.patch<OrderResponse>(`/orders/${id}/status`, { status });
    return response.data;
  }

  /**
   * Удаление заказа
   */
  async deleteOrder(id: number): Promise<void> {
    await api.delete(`/orders/${id}`);
  }
}

export const orderService = new OrderService();
